import { render } from "./DeleteButton.vue?vue&type=template&id=afe04a1e&scoped=true&ts=true"
import script from "./DeleteButton.vue?vue&type=script&lang=ts"
export * from "./DeleteButton.vue?vue&type=script&lang=ts"

import "./DeleteButton.vue?vue&type=style&index=0&id=afe04a1e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe04a1e"]])

export default __exports__